import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./header.module.less"
import React, {useEffect, useRef, useMemo} from "react";
import {
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {GpsStatusButton} from "@src/CommonComponents/GpsStatusButton/GpsStatusButton.tsx";
import {GtDatetime} from "@src/i18n/Gt.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {Properties} from "@UI/components/icons/Properties.tsx";
import {useNavigate} from "react-router-dom";
import {useLocation} from "react-router";
import cn from "classnames";
import {FlyMainMenu, InlineMenuItems} from "@src/Pages/SettingsPage/MainMenu.tsx";
import {FiltersButton} from "@src/CommonComponents/FiltersButton/FiltersButton.tsx";

export const Header = ({showFilters = false}: {showFilters: boolean}) => {
    const navigate = useNavigate()
    const location = useLocation()

    const [showMenu, setShowMenu] = React.useState(false);
    const flyMenuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!showMenu) return
        const handleClickOutside = (e: MouseEvent) => {
            if (flyMenuRef.current && !flyMenuRef.current.contains(e.target as Node)) {
                setShowMenu(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [showMenu])

    const currentDate = useMemo(() => {
        return <GtDatetime>{new Date().toString()}</GtDatetime>
    }, [])

    return (
        <Stack justifyContent={"space-between"} className={styles.root} alignItems={"center"} gap={0}>
            <Stack gap={8} className={styles.infoBlock} alignItems={"center"} >
                <Title_20_Coral_Strong_emphasis_20>{currentDate}</Title_20_Coral_Strong_emphasis_20>
                <GpsStatusButton />
            </Stack>

            <Stack alignItems={"center"} justifyContent={"center"}>
                <Stack className={styles.inlineHeadMenu} gap={32}>
                    <InlineMenuItems />
                </Stack>
            </Stack>

            <Stack alignItems={"center"}>
                {showFilters &&
                    <FiltersButton />
                }

                <Button type={ButtonType.clickableIcon} icon={<Properties/>}
                        onClick={() => navigate("/settings/", { state: { from: location } })}
                        className={cn(styles.menuButton, styles.mobile)}/>
                <Button type={ButtonType.clickableIcon} icon={<Properties/>}
                        onClick={() => setShowMenu(!showMenu)}
                        className={cn(styles.menuButton, styles.tablet)}/>
                {showMenu && <div ref={flyMenuRef}><FlyMainMenu /></div>}
            </Stack>
        </Stack>
    )
}